import React, { useEffect, useMemo, useState } from 'react';
import UserService from '../services/user/UserService';

const Role = ({ id }) => {
    let userService = useMemo(() => new UserService(), [])
    const [roleUser, setRoleUser] = useState('')

    useEffect(() => {
        try {
            const getRoleById = async () => {
                const response = await userService.getRoleById(id)
                response && setRoleUser(response.data.roleUser)
            }
            getRoleById()
        } catch (error) {
            setRoleUser('')
        }
    }, [userService, id])

    return (
        <>
            <div>{roleUser}</div>
        </>
    )
}

export default Role